import { LegalPage } from "@/components/LegalPage";

const sections = [
  {
    heading: "What we collect",
    paragraphs: [
      "When you use this website we may collect the details you share through our contact form (name, phone number, email address and your message), the email address you provide when you ask us to email you a calculator summary, and the inputs you choose in our planning tools.",
      "We do not collect account passwords, card numbers, OTPs or internet-banking credentials through this website, and we will never ask for them by email or phone.",
    ],
  },
  {
    heading: "How we use your information",
    paragraphs: [
      "We use the information you share to respond to your enquiry, to send you the calculator summaries you request, to keep records required under applicable regulations, and to improve this website.",
      "If you become a client, your information may also be used to facilitate investments or services you have explicitly asked for.",
    ],
  },
  {
    heading: "What we never do",
    paragraphs: [
      "We do not sell, rent or trade your personal information to third parties for marketing. We do not send unsolicited promotional bulk email, and we do not share your details with product providers unless you ask us to act for you.",
    ],
  },
  {
    heading: "Sharing with service providers",
    paragraphs: [
      "Your enquiry details and emails are processed through our email delivery and hosting service providers, solely to operate this website. Where you choose to invest through us, relevant details are shared with the respective mutual fund houses, registrars, or partner institutions as required to execute your instructions.",
    ],
  },
  {
    heading: "Storage & security",
    paragraphs: [
      "We apply reasonable technical and organisational safeguards to protect your information and retain it only as long as needed for the purposes above or as required by law and regulation.",
    ],
  },
  {
    heading: "Cookies & analytics",
    paragraphs: [
      "This website does not use advertising trackers. Any basic, privacy-respecting usage measurement is used only to understand which sections are helpful to visitors.",
    ],
  },
  {
    heading: "Your rights",
    paragraphs: [
      "You may ask us at any time to access, correct or delete the personal information we hold about you by writing to services@hrkapital.co.in. We will respond within a reasonable period.",
    ],
  },
  {
    heading: "Changes to this policy",
    paragraphs: [
      "If we update this policy, the revised version will be posted on this page with a new 'last updated' date.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      testId="privacy-page"
      eyebrow="Legal"
      title="Privacy Policy"
      updated="July 2026"
      sections={sections}
    />
  );
}
